module.exports = __webpack_public_path__ + "img/delivered.0b1571cb.png";